import { api } from "./api";
//import { ResourceAllocationInfo } from "@bryntum/gantt/source/lib/Engine/quark/model/scheduler_pro/SchedulerProResourceMixin.js";

window.secretDevtools = {
  checkLines: async () => {
    const records = window.gantt.taskStore.allRecords;
    const chunksize = 50;
    for (let i = 0, j = records.length; i < j; i += chunksize) {
      let postData = records.slice(i, i + chunksize);

      await api
        .post("/api/projectline/CompareProjectlineTasks", postData)
        .then((res) => res.json())
        .then((data) => console.log(data));
    }
  },
  // resourceAllocation: (resource, ticks) => {
  //   console.log(ResourceAllocationInfo.new({ resource, ticks }));
  // },
};
